import { ComponentPropsWithoutRef, ElementType } from 'react';
import { IconType } from 'react-icons';
import classNames from 'classnames';
import Typography, { TypographyProps } from '../Typography';
import { Colors } from '../../styles';
import Card from '../Card';
import styles from './Button.module.scss';

interface _ButtonProps<T extends ElementType>
  extends Pick<TypographyProps<'span'>, 'textColor'> {
  variant: 'solid' | 'outline' | 'ghost';
  buttonColor?: Colors;
  icon?: {
    placement: 'left' | 'right';
    element: IconType;
  };
  as?: T;
}

export type ButtonProps<T extends ElementType> = _ButtonProps<T> &
  ComponentPropsWithoutRef<T>;

function Button<T extends ElementType>({
  buttonColor = 'text-1',
  className,
  children,
  variant,
  icon,
  as,
  ...props
}: ButtonProps<T>) {
  return (
    <Card
      padding="0.75rem 1.5rem"
      {...props}
      className={classNames(
        buttonColor && styles[`button--c-${buttonColor}`],
        props.disabled && styles['button--disabled'],
        variant && styles[`button--t-${variant}`],
        styles.button,
        className,
      )}
      as={as ?? 'button'}
    >
      {icon?.placement === 'left' && <icon.element className={styles.icon} />}
      {children && (
        <Typography className={styles.text} textWeight="bold" textType="p1">
          {children}
        </Typography>
      )}
      {icon?.placement === 'right' && <icon.element className={styles.icon} />}
    </Card>
  );
}

export default Button;
